import React from 'react'

const Header = () => {
  return (
    <div className='ui fixed menu'>
        <div className='ui container center'>
            <h2>
                FakeStore
            </h2>

        </div>
      
    </div>
  )
}

export default Header
